<template>
  <div class="deleteUser">
    <el-dialog :visible.sync="deleteState" :before-close="deleteShow">
      <div slot="title" class="el-dialog__title">
        <div class="title-left"></div>
        <slot name="title">{{$t('common.del')+$t('common.tips')}}</slot>
        <div class="title-right"></div>
      </div>
      <div class="det_user">
        {{$t('managementV2.operationwillDelete')}}
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size='medium' @click="deleteShow">{{$t('managementV2.cancel')}}</el-button>
        <el-button size='medium' type="primary" class="confirm-btn" @click="deleteSucc()">
          {{$t('managementV2.determine')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { deleteUser } from "@/services/teamManagement.js";

export default {
  name: "deleteUser",
  props: {
    deleteState: {
      type: Boolean,
    },
    delUserId: {
      type: Number,
    },
  },
  data() {
    return {
      form: {
        email: "",
        name: "",
        role: "",
        authority: []
      }
    };
  },
  methods: {
    deleteShow() {
      this.$emit("deleteShow")
    },
    async deleteSucc() {
      let params = {
        id: this.delUserId
      }
      const res = await deleteUser(params)
      if ((res.status == 200) && (res.success)) {
        this.$message.closeAll()
        this.$message({
          message: this.$t('managementV2.userdeleteSuccess'),
          type: "success"
        });
        this.$emit('updateData');
      } else {
        this.$message.closeAll()
        this.$message({
          message: res.errorDesc,
          type: "error"
        })
      }
      this.$emit("deleteShow")
    }
  }
};
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>